<!-- <div class="card flex justify-content-center">
    <p-toast></p-toast>
    <p-fileUpload #fileUpload name="demo[]" url="https://www.primefaces.org/cdn/api/upload.php"
        (onUpload)="onUpload($event)" (onSelect)="onFileSelect($event)" [multiple]="true" [maxFileSize]="1000000"
        [auto]="false" [showUploadButton]="false" [showCancelButton]="false">
        <ng-template pTemplate="toolbar">
            <div class="flex gap-2">
                <p-button (onClick)="fileUpload.choose()" icon="fas fa-cloud-upload-alt" severity="primary"
                    label="Subir archivo" styleClass="p-button-rounded p-button-outlined"></p-button>
                
                <p-button (onClick)="fileUpload.clear()" icon="fas fa-times" severity="danger" label="Cancelar"
                    styleClass="p-button-rounded p-button-danger p-button-outlined"
                    [disabled]="!fileUpload.files || fileUpload.files.length === 0"></p-button>
            </div>
        </ng-template>
        <ng-template pTemplate="content">
            <div *ngIf="fileUpload.files.length != 0; else emptyTemplate">
                <ul>
                    <li *ngFor="let file of uploadedFiles">
                        <span class="msr-3 align-self-center img-icon primary-rgba text-primary">
                            <i [ngClass]="getIconClass(file)" class="far fa-fw"></i>
                        </span>
                        {{ file.name }} - {{ file.size }} bytes
                    </li>
                </ul>
            </div>
        </ng-template>
        <ng-template #emptyTemplate>
        <div class="flex align-items-center justify-content-center flex-column">
          <i
            class="material-icons border-2 border-circle p-5 text-8xl text-400 border-400"
          >cloud_upload</i>
          <p class="mt-4 mb-0">Arrastra y suelta archivos aquí para subir.</p>
        </div>
      </ng-template>
        <ng-template #emptyTemplate>
            <div class="d-flex flex-column align-items-center justify-content-center">
                <i class="fas fa-cloud-upload-alt fa-5x text-purple mb-4 "></i>
                <p class="text-center">Arrastra o suelta archivos aquí para subir.</p>
            </div>
        </ng-template>
    </p-fileUpload>
</div> -->
<div class="card flex justify-content-center">
  <!-- <div *ngIf="isLoading" class="overlay">
    <mat-spinner class="spinner"></mat-spinner>
  </div> -->
  <p-toast></p-toast>
  <p-fileUpload #fileUpload name="demo[]" [multiple]="maxFile" [auto]="false" [showUploadButton]="false" [showCancelButton]="false" [accept]="archivo" (onSelect)="onFileSelect($event)">
    <ng-template pTemplate="toolbar">
      <div class="flex gap-2">
        <p-button (onClick)="fileUpload.choose()" icon="fas fa-cloud-upload-alt" severity="primary"
          label="Subir archivo" styleClass="p-button-rounded p-button-outlined"></p-button>
        <p-button (onClick)="childFunction()" icon="fas fa-times" severity="danger" label="Cancelar"
          styleClass="p-button-rounded p-button-danger p-button-outlined"
          [disabled]="!fileUpload.files || fileUpload.files.length === 0"></p-button>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <!-- <div class="mb-2 mt--5" *ngIf="isLoading">
        <span>Subiendo archivo...</span>
        <mat-progress-bar mode="indeterminate" color="warn"></mat-progress-bar>
      </div> -->
      <div *ngIf="fileUpload.files.length != 0; else emptyTemplate">
        <ul>
          <li *ngFor="let file of uploadedFiles">
            <span class="msr-3 align-self-center img-icon primary-rgba text-primary">
              <i [ngClass]="getIconClass(file)" class="far fa-fw"></i>
            </span>
            {{ file.name }} - {{ file.size }} bytes
          </li>
        </ul>
      </div>
    </ng-template>
    <ng-template #emptyTemplate>
      <div class="d-flex flex-column align-items-center justify-content-center">
        <i class="fas fa-cloud-upload-alt fa-5x text-purple mb-4 "></i>
        <p class="text-center">Arrastra o suelta archivos aquí para subir.</p>
      </div>
    </ng-template>
  </p-fileUpload>
</div>